import { apiGet, apiPost } from './api-client';

export interface OnboardingStatus {
  completed: boolean;
  triggerCount: number;
  completedAt: string | null;
}

export interface CoachingPreferences {
  coachingStyle?: 'tough-love' | 'data-driven' | 'compassionate' | 'balanced';
  primaryFocus?: 'faith' | 'family' | 'finance' | 'fitness';
  goals?: string[];
  challenges?: string[];
  availabilityMinutesPerDay?: number;
}

/**
 * Get user's onboarding status
 */
export async function getOnboardingStatus(): Promise<OnboardingStatus> {
  return await apiGet<OnboardingStatus>('/api/onboarding/status');
}

/**
 * Mark onboarding as complete and save preferences
 */
export async function completeOnboarding(
  preferences?: CoachingPreferences
): Promise<{ success: boolean; message: string }> {
  return await apiPost('/api/onboarding/complete', { preferences });
}

/**
 * Reset onboarding (allows user to redo it)
 */
export async function resetOnboarding(): Promise<{ success: boolean; message: string }> {
  return await apiPost('/api/onboarding/reset');
}

/**
 * Get user's coaching preferences
 */
export async function getCoachingPreferences(): Promise<{ preferences: CoachingPreferences | null }> {
  return await apiGet<{ preferences: CoachingPreferences | null }>('/api/onboarding/preferences');
}
